import { render } from "./Mostrar-Solicitudes-Aceptadas.vue?vue&type=template&id=8b187c36&scoped=true"
import script from "./Mostrar-Solicitudes-Aceptadas.vue?vue&type=script&lang=js"
export * from "./Mostrar-Solicitudes-Aceptadas.vue?vue&type=script&lang=js"

import "./Mostrar-Solicitudes-Aceptadas.vue?vue&type=style&index=0&id=8b187c36&lang=css"
import "./Mostrar-Solicitudes-Aceptadas.vue?vue&type=style&index=1&id=8b187c36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b187c36"]])

export default __exports__